export const UpdateFlags = {
  Render: '@render',
  Update: '@update',
  Transform: '@transform',
};
